import { auth } from '../../services/firebase/auth';


export const isEmailVerified = () => {
  if (auth.currentUser?.providerData[0]?.providerId === 'facebook.com' || auth.currentUser?.providerData[0]?.providerId === 'google.com') return true;
  return auth.currentUser?.emailVerified;
};